module.exports = __webpack_public_path__ + "img/SES_140250005.514cdbee.jpg";